module.exports = __webpack_public_path__ + "static/media/buildingRegular.b4b538fa.svg";